export const slugify = str => {
    if (typeof str === 'undefined') return false
  
    return str
      .toLowerCase()
      .replace(/\s/g, '-')
      .replace(/[^\w-]+/g, '')
}